export const PreviewState = {
    Front: 'Front',
    Gtm: 'Gtm',
    Back: 'Back',
};
